var _path, _path2, _path3, _path4, _path5, _path6, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgWorkHistoryTimeline = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 500 500",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
  id: "freepik--Floor--inject-16"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 250,
  cy: 349.69,
  rx: 236.64,
  ry: 134.42,
  style: {
    fill: "#f5f5f5"
  }
})), /*#__PURE__*/React.createElement("g", {
  id: "freepik--Shadows--inject-16"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 122.62,
  cy: 331.38,
  rx: 72.14,
  ry: 41.41,
  style: {
    fill: "#e0e0e0"
  }
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 205.36,
  cy: 436.11,
  rx: 40.78,
  ry: 23.41,
  style: {
    fill: "#e0e0e0"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "269.23 438.1 294.57 438.1 476.76 333.01 297.24 223.27 214.89 274.82 338.39 347.18 225.74 412.72 269.23 438.1",
  style: {
    fill: "#e0e0e0"
  }
})), /*#__PURE__*/React.createElement("g", {
  id: "freepik--Plants--inject-16"
}, /*#__PURE__*/React.createElement("path", {
  d: "M91.35,305.71l-12.08,6.91s6.28-19.47,3.15-39.17c-1.18-7.44-3.81-11.15-4.73-13.15s-8-14.33-1.58-19.91,21.26,5.84,20.24,36.11A118.77,118.77,0,0,1,91.35,305.71Z",
  style: {
    fill: "#455a64"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.73,309.4a.45.45,0,0,1-.16,0,.49.49,0,0,1-.29-.62c0-.12,4.67-12.65,4.67-32.88s-10.27-30.92-10.37-31a.48.48,0,0,1,0-.68.49.49,0,0,1,.68,0c.11.11,10.65,11.18,10.65,31.7s-4.69,33.1-4.74,33.22A.46.46,0,0,1,85.73,309.4Z",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.68,307.14l-20,11.55s-9.06-1.46-8.27-10.09,4.5-10.62,0-14.47-5.74-4.12-5.47-7.84,2.76-5.31,3.94-6.77,4.47-4.51,2.23-9-5.28-8.88-.65-10.88c2.75-1.2,7.35.39,10.38,3.71s5.51,5.71,8.4,6.51,8.94.93,8.68,6-1.58,6.78-.4,9C89.73,289.08,99.46,291.47,88.68,307.14Z",
  style: {
    fill: "#37474f"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.55,312.32h0a.48.48,0,0,1-.44-.52c0-.3,2.49-29.68-17.47-49.2a.48.48,0,1,1,.67-.68c20.29,19.84,17.79,49.67,17.76,50A.47.47,0,0,1,80.55,312.32Z",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.29,286.67h0a.49.49,0,0,1-.44-.52,17.78,17.78,0,0,1,6.6-12.6.48.48,0,0,1,.67.12.47.47,0,0,1-.11.67,17.12,17.12,0,0,0-6.2,11.89A.48.48,0,0,1,77.29,286.67Z",
  style: {
    fill: "#fff"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.7,291.79a.48.48,0,0,1-.36-.17c0-.05-5-5.54-16.4-4.09a.48.48,0,0,1-.12-1c11.94-1.51,17,4.18,17.24,4.42a.48.48,0,0,1,0,.68A.47.47,0,0,1,78.7,291.79Z",
  style: {
    fill: "#fff"
  }
})), /*#__PURE__*/React.createElement("g", {
  id: "freepik--sand-clock--inject-16"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 123.91,
  cy: 315.85,
  rx: 60.9,
  ry: 34.96,
  style: {
    fill: "#37474f"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M184.81,315.85c0,19.31-27.26,35-60.9,35S63,335.16,63,315.85h0v9.77c0,19.3,27.26,34.95,60.89,34.95s60.9-15.65,60.9-34.95v-9.77Z",
  style: {
    fill: "#253239"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M123.91,346.64c-31.23,0-56.64-13.81-56.64-30.79s25.41-30.79,56.64-30.79,56.65,13.81,56.65,30.79S155.15,346.64,123.91,346.64Zm0-60.52c-30.65,0-55.59,13.33-55.59,29.73s24.94,29.73,55.59,29.73,55.59-13.34,55.59-29.73S154.57,286.12,123.91,286.12Z",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M123.91,161.43c-31.23,0-56.64-13.82-56.64-30.8s25.41-30.79,56.64-30.79,56.65,13.81,56.65,30.79S155.15,161.43,123.91,161.43Zm0-60.53c-30.65,0-55.59,13.34-55.59,29.73s24.94,29.74,55.59,29.74S179.5,147,179.5,130.63,154.57,100.9,123.91,100.9Z",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "179.5 315.86 179.5 315.85 180.56 315.85 179.5 315.86",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "67.27 315.86 67.27 315.85 68.33 315.85 67.27 315.86",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M180.56,315.85H179.5c0-16.4-24.93-29.73-55.59-29.73s-55.59,13.33-55.59,29.73h-1V283.42A49,49,0,0,1,93,240.17l15.47-8.33a8.71,8.71,0,0,0,0-15.31L93,208.2A49,49,0,0,1,67.27,165V132h1.12l0,.47c1.79,15.65,26.15,27.91,55.47,27.91s53.69-12.26,55.48-27.91l.05-.47h1.12v33a49,49,0,0,1-25.69,43.24l-15.48,8.33a8.72,8.72,0,0,0,0,15.31l15.48,8.33c15.69,9.23,25.53,25.79,25.69,43.25Zm-56.65-30.79c27.5,0,50.48,10.7,55.59,24.84V283.42c-.15-17.08-9.79-33.3-25.15-42.32l-15.46-8.32a9.78,9.78,0,0,1,0-17.18l15.48-8.33A47.93,47.93,0,0,0,179.5,165v-28.4c-5.1,14.23-28.23,24.87-55.59,24.87s-50.48-10.64-55.59-24.87V165a47.94,47.94,0,0,0,25.14,42.31l15.48,8.33a9.78,9.78,0,0,1,0,17.18l-15.48,8.33a47.93,47.93,0,0,0-25.14,42.31V309.9C73.43,295.76,96.42,285.06,123.91,285.06Z",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.68,260.23a9.59,9.59,0,0,0-9.53,0c-12.6,7.21-45.84,27.36-45.84,39.57,0,15.07,22.65,27.29,50.6,27.29s50.61-12.22,50.61-27.29C174.52,287.59,141.28,267.44,128.68,260.23Z",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M128.68,260.23a9.59,9.59,0,0,0-9.53,0c-12.6,7.21-45.84,27.36-45.84,39.57,0,15.07,22.65,27.29,50.6,27.29s50.61-12.22,50.61-27.29C174.52,287.59,141.28,267.44,128.68,260.23Z",
  style: {
    fill: "#fff",
    opacity: 0.30000000000000004
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M123.91,327.09c-27.95,0-50.6-12.22-50.6-27.29v13.83h0c0,15.07,22.66,27.29,50.6,27.29s50.61-12.22,50.61-27.29h0V299.8C174.52,314.87,151.86,327.09,123.91,327.09Z",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.31,132.52v30a43.77,43.77,0,0,0,22.92,38.58l14,7.51c.21.12.42.24.61.37.5.32,1,.63,1.52.92a19.89,19.89,0,0,1,9.34,16.89v13a2.28,2.28,0,0,0,2.26,2.29h0a2.29,2.29,0,0,0,2.27-2.29v-13a19.9,19.9,0,0,1,9.33-16.89c.52-.29,1-.6,1.53-.92.19-.13.4-.25.61-.37l13.95-7.51a43.77,43.77,0,0,0,22.92-38.58v-30Z",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M126.18,249.11a2.27,2.27,0,1,0-2.27,2.28A2.29,2.29,0,0,0,126.18,249.11Z",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.31,132.52v30a43.77,43.77,0,0,0,22.92,38.58l14,7.51c.21.12.42.24.61.37.5.32,1,.63,1.52.92a19.89,19.89,0,0,1,9.34,16.89v13a2.28,2.28,0,0,0,2.26,2.29h0a2.29,2.29,0,0,0,2.27-2.29v-13a19.9,19.9,0,0,1,9.33-16.89c.52-.29,1-.6,1.53-.92.19-.13.4-.25.61-.37l13.95-7.51a43.77,43.77,0,0,0,22.92-38.58v-30Z",
  style: {
    fill: "#fff",
    opacity: 0.30000000000000004
  }
}), /*#__PURE__*/React.createElement("g", {
  style: {
    opacity: 0.30000000000000004
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M126.18,249.11a2.27,2.27,0,1,0-2.27,2.28A2.29,2.29,0,0,0,126.18,249.11Z",
  style: {
    fill: "#fff"
  }
})), /*#__PURE__*/React.createElement("ellipse", {
  cx: 123.91,
  cy: 132.52,
  rx: 50.61,
  ry: 27.29,
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("g", {
  style: {
    opacity: 0.5,
    mixBlendMode: "overlay"
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M119.75,232.31l-9.84,8.33c-10,8.42-16.16,24.87-16.16,42.78v57.06a65.42,65.42,0,0,1-8.9-3.8V283.42c0-17.91,7.11-34.36,18.51-42.78l11.25-8.33c4.69-3.47,4.69-12.79,0-16.24l-11.25-8.33C92,199.32,84.85,182.86,84.85,165V132.52h8.9V165c0,17.91,6.21,34.37,16.16,42.79l9.84,8.33C123.84,219.52,123.84,228.84,119.75,232.31Z",
  style: {
    fill: "#fff"
  }
})), /*#__PURE__*/React.createElement("ellipse", {
  cx: 123.91,
  cy: 130.63,
  rx: 60.9,
  ry: 34.96,
  style: {
    fill: "#37474f"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M184.81,130.63c0,19.31-27.26,35-60.9,35S63,149.94,63,130.63h0v9.77c0,19.31,27.26,35,60.89,35s60.9-15.65,60.9-35v-9.77Z",
  style: {
    fill: "#253239"
  }
})), /*#__PURE__*/React.createElement("g", {
  id: "freepik--Stairs--inject-16"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "323.19 227.96 323.19 189.38 269.25 157.92 269.25 119.34 215.32 87.87 215.32 280.76 269.25 312.23 323.19 343.69 377.12 375.16 377.12 259.43 323.19 227.96",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "323.19 227.96 323.19 266.54 377.12 298.01 377.12 259.43 323.19 227.96",
  style: {
    fill: "#fff",
    opacity: 0.30000000000000004
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "377.12 259.43 377.12 298.01 323.19 329.48 323.19 368.05 269.25 399.52 269.25 438.1 323.19 406.63 377.12 375.16 431.06 343.69 431.06 227.96 377.12 259.43",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "377.12 259.43 377.12 298.01 323.19 329.48 323.19 368.05 269.25 399.52 269.25 438.1 323.19 406.63 377.12 375.16 431.06 343.69 431.06 227.96 377.12 259.43",
  style: {
    fill: "#fff",
    opacity: 0.1
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "269.25 119.34 215.32 87.87 269.25 56.4 323.19 87.87 269.25 119.34",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "269.25 119.34 215.32 87.87 269.25 56.4 323.19 87.87 269.25 119.34",
  style: {
    fill: "#fff",
    opacity: 0.7000000000000001
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "269.25 157.92 269.25 119.34 323.19 87.87 323.19 126.45 269.25 157.92",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "269.25 157.92 269.25 119.34 323.19 87.87 323.19 126.45 269.25 157.92",
  style: {
    opacity: 0.1
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "323.19 189.38 269.25 157.92 323.19 126.45 377.12 157.92 323.19 189.38",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "323.19 227.96 323.19 189.38 377.12 157.92 377.12 196.49 323.19 227.96",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "323.19 189.38 269.25 157.92 323.19 126.45 377.12 157.92 323.19 189.38",
  style: {
    fill: "#fff",
    opacity: 0.7000000000000001
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "323.19 227.96 323.19 189.38 377.12 157.92 377.12 196.49 323.19 227.96",
  style: {
    opacity: 0.1
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "377.12 259.43 323.19 227.96 377.12 196.49 431.06 227.96 377.12 259.43",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("g", {
  style: {
    opacity: 0.7000000000000001
  }
}, /*#__PURE__*/React.createElement("polygon", {
  points: "377.12 259.43 323.19 227.96 377.12 196.49 431.06 227.96 377.12 259.43",
  style: {
    fill: "#fff"
  }
})), /*#__PURE__*/React.createElement("polygon", {
  points: "323.19 329.48 377.12 298.01 323.19 266.54 269.25 298.01 323.19 329.48",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "323.19 329.48 377.12 298.01 323.19 266.54 269.25 298.01 323.19 329.48",
  style: {
    fill: "#fff",
    opacity: 0.7000000000000001
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "323.19 368.05 323.19 329.48 269.25 298.01 269.25 336.59 323.19 368.05",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "323.19 368.05 323.19 329.48 269.25 298.01 269.25 336.59 323.19 368.05",
  style: {
    fill: "#fff",
    opacity: 0.30000000000000004
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "269.25 399.52 323.19 368.05 269.25 336.59 215.32 368.05 269.25 399.52",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "269.25 438.1 269.25 399.52 215.32 368.05 215.32 406.63 269.25 438.1",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "269.25 399.52 323.19 368.05 269.25 336.59 215.32 368.05 269.25 399.52",
  style: {
    fill: "#fff",
    opacity: 0.7000000000000001
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "269.25 438.1 269.25 399.52 215.32 368.05 215.32 406.63 269.25 438.1",
  style: {
    fill: "#fff",
    opacity: 0.30000000000000004
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "312.76 361.97 258.83 393.44 225.75 374.14 279.69 342.67 312.76 361.97",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "312.76 361.97 258.83 393.44 225.75 374.14 279.69 342.67 312.76 361.97",
  style: {
    fill: "#fff",
    opacity: 0.4
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "258.83 393.44 258.83 432.01 225.74 412.72 225.74 374.14 225.75 374.14 258.83 393.44",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "366.7 291.92 312.76 323.39 279.69 304.1 333.62 272.63 366.7 291.92",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "366.7 291.92 312.76 323.39 279.69 304.1 333.62 272.63 366.7 291.92",
  style: {
    fill: "#fff",
    opacity: 0.4
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "312.76 323.39 312.76 361.97 279.68 342.67 279.68 304.1 279.69 304.1 312.76 323.39",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "366.7 253.35 366.7 291.92 333.61 272.63 333.61 234.05 333.62 234.05 366.7 253.35",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "366.7 253.35 366.7 291.92 333.61 272.63 333.61 234.05 333.62 234.05 366.7 253.35",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "279.68 151.83 333.61 183.3 366.69 164.01 312.75 132.53 279.68 151.83",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "279.68 151.83 333.61 183.3 366.69 164.01 312.75 132.53 279.68 151.83",
  style: {
    fill: "#fff",
    opacity: 0.5,
    mixBlendMode: "overlay"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "333.61 183.3 333.61 221.88 366.7 202.58 366.7 164.01 366.69 164.01 333.61 183.3",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "333.61 183.3 333.61 221.88 366.7 202.58 366.7 164.01 366.69 164.01 333.61 183.3",
  style: {
    opacity: 0.30000000000000004
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "225.74 81.78 279.68 113.26 312.75 93.96 258.82 62.49 225.74 81.78",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "225.74 81.78 279.68 113.26 312.75 93.96 258.82 62.49 225.74 81.78",
  style: {
    fill: "#fff",
    opacity: 0.5,
    mixBlendMode: "overlay"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "279.68 113.26 279.68 151.83 312.76 132.53 312.76 93.96 312.75 93.96 279.68 113.26",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "279.68 113.26 279.68 151.83 312.76 132.53 312.76 93.96 312.75 93.96 279.68 113.26",
  style: {
    opacity: 0.30000000000000004
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "377.12 208.67 366.69 202.57 333.61 221.87 344.05 227.96 333.62 234.05 366.7 253.34 377.12 247.26 410.2 227.96 377.12 208.67",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "377.12 208.67 366.69 202.57 333.61 221.87 344.05 227.96 333.62 234.05 366.7 253.34 377.12 247.26 410.2 227.96 377.12 208.67",
  style: {
    fill: "#fff",
    opacity: 0.4
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M247.77,75.82a.53.53,0,0,1-.24-.06l-2-1.18a.48.48,0,0,1-.17-.66.48.48,0,0,1,.65-.18l2,1.18a.49.49,0,0,1,.18.66A.47.47,0,0,1,247.77,75.82Z",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M287.38,98.94a.44.44,0,0,1-.24-.07l-4-2.31a.48.48,0,0,1,.48-.84l4,2.31a.48.48,0,0,1,.17.66A.46.46,0,0,1,287.38,98.94Zm-7.92-4.63a.53.53,0,0,1-.24-.06l-4-2.31a.48.48,0,0,1,.48-.84l4,2.31a.48.48,0,0,1,.17.66A.45.45,0,0,1,279.46,94.31Zm-7.92-4.62a.5.5,0,0,1-.24-.06l-4-2.31a.5.5,0,0,1-.18-.67.48.48,0,0,1,.66-.17l4,2.31a.48.48,0,0,1-.24.9Zm-7.92-4.62a.4.4,0,0,1-.24-.07l-4-2.31a.49.49,0,0,1-.18-.66.47.47,0,0,1,.65-.17l4,2.31a.49.49,0,0,1,.17.66A.49.49,0,0,1,263.62,85.07Zm-7.93-4.62a.44.44,0,0,1-.24-.07l-4-2.31a.49.49,0,0,1-.17-.66.48.48,0,0,1,.65-.18l4,2.31a.49.49,0,0,1,.18.66A.48.48,0,0,1,255.69,80.45Z",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M293.36,102.43a.44.44,0,0,1-.24-.07l-2-1.18a.48.48,0,0,1-.17-.66.46.46,0,0,1,.65-.17l2,1.17a.49.49,0,0,1,.18.66A.48.48,0,0,1,293.36,102.43Z",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("g", {
  style: {
    opacity: 0.30000000000000004
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M247.77,75.82a.53.53,0,0,1-.24-.06l-2-1.18a.48.48,0,0,1-.17-.66.48.48,0,0,1,.65-.18l2,1.18a.49.49,0,0,1,.18.66A.47.47,0,0,1,247.77,75.82Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M287.38,98.94a.44.44,0,0,1-.24-.07l-4-2.31a.48.48,0,0,1,.48-.84l4,2.31a.48.48,0,0,1,.17.66A.46.46,0,0,1,287.38,98.94Zm-7.92-4.63a.53.53,0,0,1-.24-.06l-4-2.31a.48.48,0,0,1,.48-.84l4,2.31a.48.48,0,0,1,.17.66A.45.45,0,0,1,279.46,94.31Zm-7.92-4.62a.5.5,0,0,1-.24-.06l-4-2.31a.5.5,0,0,1-.18-.67.48.48,0,0,1,.66-.17l4,2.31a.48.48,0,0,1-.24.9Zm-7.92-4.62a.4.4,0,0,1-.24-.07l-4-2.31a.49.49,0,0,1-.18-.66.47.47,0,0,1,.65-.17l4,2.31a.49.49,0,0,1,.17.66A.49.49,0,0,1,263.62,85.07Zm-7.93-4.62a.44.44,0,0,1-.24-.07l-4-2.31a.49.49,0,0,1-.17-.66.48.48,0,0,1,.65-.18l4,2.31a.49.49,0,0,1,.18.66A.48.48,0,0,1,255.69,80.45Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M293.36,102.43a.44.44,0,0,1-.24-.07l-2-1.18a.48.48,0,0,1-.17-.66.46.46,0,0,1,.65-.17l2,1.17a.49.49,0,0,1,.18.66A.48.48,0,0,1,293.36,102.43Z"
}))), /*#__PURE__*/React.createElement("path", {
  d: "M301.42,145.7a.44.44,0,0,1-.24-.07l-2-1.18a.48.48,0,0,1-.17-.66.47.47,0,0,1,.65-.17l2,1.18a.48.48,0,0,1-.24.9Z",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M341.07,168.84a.39.39,0,0,1-.23-.07l-4-2.31a.48.48,0,0,1,.48-.84l4,2.32a.49.49,0,0,1,.18.66A.49.49,0,0,1,341.07,168.84Zm-7.93-4.63a.53.53,0,0,1-.24-.06l-4-2.32a.48.48,0,0,1,.48-.84l4,2.32a.48.48,0,0,1-.24.9Zm-7.93-4.63a.53.53,0,0,1-.24-.06l-4-2.32a.49.49,0,0,1-.18-.66.48.48,0,0,1,.66-.17l4,2.31a.49.49,0,0,1,.18.66A.47.47,0,0,1,325.21,159.58ZM317.28,155a.53.53,0,0,1-.24-.06l-4-2.31a.49.49,0,0,1-.18-.66.48.48,0,0,1,.66-.18l4,2.31a.49.49,0,0,1,.18.66A.47.47,0,0,1,317.28,155Zm-7.93-4.62a.44.44,0,0,1-.24-.07l-4-2.31a.48.48,0,1,1,.48-.84l4,2.31a.5.5,0,0,1,.18.67A.49.49,0,0,1,309.35,150.33Z",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M347.06,172.33a.53.53,0,0,1-.24-.06l-2-1.18a.48.48,0,0,1-.17-.66.47.47,0,0,1,.65-.18l2,1.18a.48.48,0,0,1,.17.66A.49.49,0,0,1,347.06,172.33Z",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("g", {
  style: {
    opacity: 0.30000000000000004
  }
}, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M301.42,145.7a.44.44,0,0,1-.24-.07l-2-1.18a.48.48,0,0,1-.17-.66.47.47,0,0,1,.65-.17l2,1.18a.48.48,0,0,1-.24.9Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M341.07,168.84a.39.39,0,0,1-.23-.07l-4-2.31a.48.48,0,0,1,.48-.84l4,2.32a.49.49,0,0,1,.18.66A.49.49,0,0,1,341.07,168.84Zm-7.93-4.63a.53.53,0,0,1-.24-.06l-4-2.32a.48.48,0,0,1,.48-.84l4,2.32a.48.48,0,0,1-.24.9Zm-7.93-4.63a.53.53,0,0,1-.24-.06l-4-2.32a.49.49,0,0,1-.18-.66.48.48,0,0,1,.66-.17l4,2.31a.49.49,0,0,1,.18.66A.47.47,0,0,1,325.21,159.58ZM317.28,155a.53.53,0,0,1-.24-.06l-4-2.31a.49.49,0,0,1-.18-.66.48.48,0,0,1,.66-.18l4,2.31a.49.49,0,0,1,.18.66A.47.47,0,0,1,317.28,155Zm-7.93-4.62a.44.44,0,0,1-.24-.07l-4-2.31a.48.48,0,1,1,.48-.84l4,2.31a.5.5,0,0,1,.18.67A.49.49,0,0,1,309.35,150.33Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M347.06,172.33a.53.53,0,0,1-.24-.06l-2-1.18a.48.48,0,0,1-.17-.66.47.47,0,0,1,.65-.18l2,1.18a.48.48,0,0,1,.17.66A.49.49,0,0,1,347.06,172.33Z"
}))), /*#__PURE__*/React.createElement("path", {
  d: "M350.16,244.17a.49.49,0,0,1-.41-.24.49.49,0,0,1,.17-.66l2-1.18a.48.48,0,0,1,.65.18.49.49,0,0,1-.18.66l-2,1.18A.48.48,0,0,1,350.16,244.17Z",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M356.77,240.32a.46.46,0,0,1-.41-.24.47.47,0,0,1,.17-.66l4.58-2.68a.48.48,0,0,1,.66.18.49.49,0,0,1-.18.66L357,240.25A.44.44,0,0,1,356.77,240.32Zm9.17-5.35a.49.49,0,0,1-.42-.24.49.49,0,0,1,.18-.66l4.58-2.68a.48.48,0,0,1,.48.84l-4.58,2.67A.44.44,0,0,1,365.94,235Z",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M375.11,229.62a.49.49,0,0,1-.42-.24.49.49,0,0,1,.18-.66l1.29-.76-1.29-.76a.48.48,0,1,1,.48-.84l2,1.18a.5.5,0,0,1,.22.55.49.49,0,0,1-.3.33l-2,1.13A.39.39,0,0,1,375.11,229.62Z",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M371.13,224.94a.48.48,0,0,1-.24-.06l-4-2.32a.49.49,0,0,1-.18-.66.47.47,0,0,1,.65-.18l4,2.32a.49.49,0,0,1,.17.66A.47.47,0,0,1,371.13,224.94Zm-8-4.64a.39.39,0,0,1-.23-.07l-4-2.32a.49.49,0,0,1-.17-.66.48.48,0,0,1,.65-.18l4,2.32a.5.5,0,0,1,.18.67A.49.49,0,0,1,363.16,220.3Z",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M355.2,215.65a.53.53,0,0,1-.24-.06l-2-1.18a.49.49,0,0,1-.17-.66.48.48,0,0,1,.65-.18l2,1.18a.48.48,0,0,1-.24.9Z",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M348.13,283.92a.47.47,0,0,1-.41-.24.49.49,0,0,1,.18-.66l2-1.18a.48.48,0,0,1,.65.18.49.49,0,0,1-.18.66l-2,1.18A.48.48,0,0,1,348.13,283.92Z",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M302.09,310.79a.47.47,0,0,1-.41-.24.48.48,0,0,1,.17-.66l3.84-2.24a.48.48,0,0,1,.65.18.48.48,0,0,1-.17.66l-3.84,2.24A.5.5,0,0,1,302.09,310.79Zm7.68-4.48a.47.47,0,0,1-.42-.24.49.49,0,0,1,.18-.66l3.83-2.24a.48.48,0,1,1,.48.84L310,306.25A.46.46,0,0,1,309.77,306.31Zm7.67-4.47a.46.46,0,0,1-.41-.24.49.49,0,0,1,.17-.67L321,298.7a.47.47,0,0,1,.65.17.49.49,0,0,1-.17.66l-3.84,2.24A.44.44,0,0,1,317.44,301.84Zm7.67-4.48a.49.49,0,0,1-.41-.24.49.49,0,0,1,.17-.66l3.84-2.24a.46.46,0,0,1,.65.17.47.47,0,0,1-.17.66l-3.84,2.24A.42.42,0,0,1,325.11,297.36Zm7.68-4.48a.48.48,0,0,1-.24-.9l3.84-2.24a.47.47,0,0,1,.65.18.49.49,0,0,1-.18.66L333,292.82A.53.53,0,0,1,332.79,292.88Zm7.67-4.48a.45.45,0,0,1-.41-.24.48.48,0,0,1,.17-.66l3.84-2.24a.48.48,0,0,1,.65.18.48.48,0,0,1-.17.66l-3.84,2.24A.53.53,0,0,1,340.46,288.4Z",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M296.23,314.21a.49.49,0,0,1-.41-.24.49.49,0,0,1,.17-.66l2-1.18a.47.47,0,0,1,.65.18.49.49,0,0,1-.18.66l-2,1.18A.48.48,0,0,1,296.23,314.21Z",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M294.2,354a.47.47,0,0,1-.41-.24.5.5,0,0,1,.17-.66l2-1.18a.48.48,0,0,1,.65.18.49.49,0,0,1-.18.66l-2,1.18A.48.48,0,0,1,294.2,354Z",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M248.16,380.83a.45.45,0,0,1-.41-.24.48.48,0,0,1,.17-.66l3.84-2.24a.48.48,0,0,1,.65.18.48.48,0,0,1-.17.66l-3.84,2.24A.53.53,0,0,1,248.16,380.83Zm7.67-4.48a.47.47,0,0,1-.41-.24.5.5,0,0,1,.17-.66l3.84-2.24a.48.48,0,1,1,.48.84l-3.84,2.24A.48.48,0,0,1,255.83,376.35Zm7.68-4.47a.48.48,0,0,1-.42-.25.49.49,0,0,1,.18-.66l3.84-2.23a.47.47,0,0,1,.65.17.49.49,0,0,1-.18.66l-3.83,2.24A.44.44,0,0,1,263.51,371.88Zm7.67-4.48a.48.48,0,0,1-.24-.9l3.84-2.24a.46.46,0,0,1,.65.17.47.47,0,0,1-.17.66l-3.84,2.24A.42.42,0,0,1,271.18,367.4Zm7.68-4.48a.48.48,0,0,1-.24-.9l3.83-2.24a.48.48,0,0,1,.66.18.49.49,0,0,1-.18.66l-3.84,2.24A.46.46,0,0,1,278.86,362.92Zm7.67-4.48a.45.45,0,0,1-.41-.24.48.48,0,0,1,.17-.66l3.84-2.24a.48.48,0,0,1,.65.18.5.5,0,0,1-.17.66l-3.84,2.24A.53.53,0,0,1,286.53,358.44Z",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M242.3,384.25a.49.49,0,0,1-.41-.24.49.49,0,0,1,.17-.66l2-1.18a.48.48,0,0,1,.66.18.49.49,0,0,1-.18.66l-2,1.18A.5.5,0,0,1,242.3,384.25Z",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M273.86,90.56a10.09,10.09,0,0,1-9.23,0c-2.54-1.48-2.54-3.89,0-5.38a10.09,10.09,0,0,1,9.23,0C276.41,86.67,276.41,89.08,273.86,90.56Z",
  style: {
    fill: "#455a64"
  }
}), /*#__PURE__*/React.createElement("polygon", {
  points: "269.25 61.96 269.25 40.3 297.24 51.13 269.25 61.96",
  style: {
    fill: "#F4590D"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M269.25,88.84a1,1,0,0,1-1-1V36.05a1,1,0,1,1,1.92,0V87.87A1,1,0,0,1,269.25,88.84Z",
  style: {
    fill: "#263238"
  }
}), /*#__PURE__*/React.createElement("text", {
  transform: "matrix(0.86, -0.5, 0, 1, 285.63, 131.83)",
  style: {
    fontSize: "9.43124008178711px",
    fill: "#f4f4f4",
    fontFamily: "Montserrat-Black, Montserrat",
    fontWeight: 800
  }
}, "2060"), /*#__PURE__*/React.createElement("text", {
  transform: "matrix(0.86, -0.5, 0, 1, 339.74, 201.77)",
  style: {
    fontSize: "9.43124008178711px",
    fill: "#f4f4f4",
    fontFamily: "Montserrat-Black, Montserrat",
    fontWeight: 800
  }
}, "2050"), /*#__PURE__*/React.createElement("text", {
  transform: "matrix(0.86, 0.5, 0, 1, 339.33, 259.4)",
  style: {
    fontSize: "9.431180000305176px",
    fill: "#f4f4f4",
    fontFamily: "Montserrat-Black, Montserrat",
    fontWeight: 800
  }
}, "2040"), /*#__PURE__*/React.createElement("text", {
  transform: "matrix(0.86, 0.5, 0, 1, 285.83, 329.7)",
  style: {
    fontSize: "9.431180000305176px",
    fill: "#f4f4f4",
    fontFamily: "Montserrat-Black, Montserrat",
    fontWeight: 800
  }
}, "2", /*#__PURE__*/React.createElement("tspan", {
  x: 5.73,
  y: 0,
  style: {
    letterSpacing: "-0.010018677468792335em"
  }
}, "0"), _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
  x: 12.17,
  y: 0
}, "30"))), /*#__PURE__*/React.createElement("text", {
  transform: "matrix(0.86, 0.5, 0, 1, 231.92, 402.37)",
  style: {
    fontSize: "9.431180000305176px",
    fill: "#f4f4f4",
    fontFamily: "Montserrat-Black, Montserrat",
    fontWeight: 800
  }
}, "2", /*#__PURE__*/React.createElement("tspan", {
  x: 5.73,
  y: 0,
  style: {
    letterSpacing: "-0.010018677468792335em"
  }
}, "0"), /*#__PURE__*/React.createElement("tspan", {
  x: 12.17,
  y: 0,
  style: {
    letterSpacing: "-0.00010436122363325349em"
  }
}, "20"))), /*#__PURE__*/React.createElement("g", {
  id: "freepik--Character--inject-16"
}, /*#__PURE__*/React.createElement("rect", {
  x: 209.91,
  y: 254.92,
  width: 11.7,
  height: 18.86,
  style: {
    fill: "#ffa8a7"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M228.6,250.6l2.78,4a.88.88,0,0,1-.11,1.14,4.24,4.24,0,0,1-2.67,1.35Z",
  style: {
    fill: "#f28f8f"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M216.88,235.81s9.11-6.46,12,16c2.38,18.67-9.21,14.39-13.52,11.81s-12.55-10.36-7.13-21.3C210.68,237.35,216.88,235.81,216.88,235.81Z",
  style: {
    fill: "#ffa8a7"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M225.28,243s.07,4.09-3.67,4.29a5.44,5.44,0,0,1,1.31,3.88c0,2.66-.91,2.15-1.31,1.64s-4.55,0-4.55,0l2.12,4a9,9,0,0,1-2.93,8.28s-5.56,1.53-8.09,0c0,0-7-7.77-8.29-13.28s-1.31-10.32,1.92-12.57c0,0,1-6.95,8.39-6.95s9.56,1.9,13.55,1c1.62-.36,4.05-1.53,4.05.1s-2,3-2,3,2-.11,3.08-.21,3.49-.46,3.08,2.66S228.74,243.54,225.28,243Z",
  style: {
    fill: "#263238"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M202.77,239.49s-1.94-3.92-4.36-1.66a.18.18,0,0,0,0,.27l4.33,2.61Z",
  style: {
    fill: "#263238"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M221.61,252.84v6.07s-6.28-.12-6.28-4.77C215.33,249.86,220.38,250.82,221.61,252.84Z",
  style: {
    fill: "#ffa8a7"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.72,410.37s-.29,8.07,10.91,11.38C186.63,421.75,188.3,410.37,175.72,410.37Z",
  style: {
    fill: "#253239"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M184.45,428.53v-4.86a6.73,6.73,0,0,1,2.6-5.32s-1.66-7.09-8.38-6.67a11.63,11.63,0,0,0-5.37,4.22,5.68,5.68,0,0,0-1,4.62h0a1,1,0,0,1,1.36-1.16l1.62.67a6.67,6.67,0,0,1,4,4.82l2,9.45a4.36,4.36,0,0,0,3.58,3.49H185a5.07,5.07,0,0,0,.55,0h.15a4.93,4.93,0,0,0,.54-.05l.15,0a5.41,5.41,0,0,0,.55-.12l.12,0a4,4,0,0,0,.65-.25,4.63,4.63,0,0,0,.65-.36l1.7-1.11a1.69,1.69,0,0,0,.77-1.49C190.7,432.49,189.85,428.53,184.45,428.53Z",
  style: {
    fill: "#37474f"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M190,435.88l-1.7,1.11a4.63,4.63,0,0,1-.65.36,4,4,0,0,1-.65.25l-.12,0a5.41,5.41,0,0,1-.55.12l-.15,0-.21,0-.33,0h-.35l-.35,0h-.11a4.36,4.36,0,0,1-3.56-3.4.29.29,0,0,0,0-.09l-2-9.45a6.67,6.67,0,0,0-4-4.82l-1.62-.67c-.71-.32-1.17.23-1.46.51a1.85,1.85,0,0,0-.54,1.94l2,8.79a8.15,8.15,0,0,0,3.33,4.94l4.27,2.93a5.62,5.62,0,0,0,4.73.61H186l.1,0a6.87,6.87,0,0,0,.88-.38l0,0,1.83-1a3,3,0,0,0,1.52-2.1A1.34,1.34,0,0,1,190,435.88Z",
  style: {
    fill: "#263238"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M177.28,412.32s7.68.74,7.65,8.86l4.77-7.45-7.83-8.18Z",
  style: {
    fill: "#ffa8a7"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M194.36,318.32v12.94q0,7.73.7,15.42L196.63,364a14.51,14.51,0,0,1-4.12,11.57,32.57,32.57,0,0,0-5.88,8.3c-4.75,9.35-10.91,26.49-10.91,26.49s10.91,0,10.91,11.38l24.85-41.48a23.83,23.83,0,0,0,3.24-9.63L220,323.22Z",
  style: {
    fill: "#455a64"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M249.06,392.93a4.31,4.31,0,0,0,2.05,1.86l.1,0a7.63,7.63,0,0,0,5.71.19l15.82-5.75c1.12-.49,1.14-2.16,1.07-2.85H249.06Z",
  style: {
    fill: "#263238"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M250,383.56s-2.23,2.32-1.41,6.71a4.35,4.35,0,0,0,2.53,3.16l.1.05a7.63,7.63,0,0,0,5.71.18l15.82-5.75a1.66,1.66,0,0,0,1-2c-.73-2.57-3.31-5.16-9.29-3.59a22.63,22.63,0,0,1-4.65,1L259,382Z",
  style: {
    fill: "#37474f"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M259.81,383.27h0c-.83,2.22-4,3-7.66,1.77a7.51,7.51,0,0,1-2.3-1.27h0V375h10Z",
  style: {
    fill: "#ffa8a7"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M205.68,321.63v1.48a20.27,20.27,0,0,0,15,19.63l25.48,6.74a1.69,1.69,0,0,1,1.26,1.64v30.42s12.3,6.18,15.86-3.4V345.28a13.33,13.33,0,0,0-8.42-12.44l-26.45-10.38Z",
  style: {
    fill: "#455a64"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M216.82,351.61l1-10.06s-8.2-2.75-9.46-6.52c-.42,3.91,5.07,7.49,6.45,8.29C215.32,346.35,216.82,351.61,216.82,351.61Z",
  style: {
    fill: "#37474f"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M207.74,273.37s.23-4.83,1.89-4.83c1.33,0,8.07,1.91,10.67,2.67a2.92,2.92,0,0,1,1.71,1.27,10.15,10.15,0,0,1,1.77,5.1Z",
  style: {
    fill: "#37474f"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M237.52,289.94s7.53-7.66,8.59-7c1.3.82-.27,3.77-1.46,5l5.91-3.86a1.59,1.59,0,0,1,2.27.57c1.65,3,3.43,10-12.36,14.64Z",
  style: {
    fill: "#ffa8a7"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M242.7,300.2s-3.92,1.8-9,4c-8.52,3.72-20.31,8.63-22.47,8.28a121.89,121.89,0,0,1-16.74-3.92l1.09-15.16,16.32,4.8,24.46-9.59,1-.4C244.26,290.75,242.7,300.2,242.7,300.2Z",
  style: {
    fill: "#263238"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M205.7,270.86l-6.09-1.67a6.63,6.63,0,0,0-8.36,6.46v2.17a18.09,18.09,0,0,0,7.24,14.51l7.09,5.3Z",
  style: {
    fill: "#37474f"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M231.78,312.65l4.77,21.46s-13.21,6.63-27.52,2.45-16-7.77-16-7.77l1.46-20.21,1.09-15.16,1.28-17.67a5.91,5.91,0,0,1,7.29-5.36l20.06,5a16.46,16.46,0,0,1,12.37,16l-2.88,12.85Z",
  style: {
    fill: "#263238"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M241.33,338.1s7.87,7.14,7.37,8.29-3.75-.08-5-1.2l4.13,5.75a1.62,1.62,0,0,1-.45,2.32c-2.86,1.83-9.71,4-15.12-11.69Z",
  style: {
    fill: "#ffa8a7"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M227.26,276.49s-7.29,14-9.62,36.25c-.37,3.51,13.83,31.13,13.83,31.13s9.42,1.07,11.55-6l-11.24-25.19,4.71-20.34a10.85,10.85,0,0,0-.1-5.4C235.42,283.45,233,278.15,227.26,276.49Z",
  style: {
    fill: "#37474f"
  }
})), /*#__PURE__*/React.createElement("g", {
  id: "freepik--Clouds--inject-16"
}, /*#__PURE__*/React.createElement("path", {
  d: "M375.67,100.17l10.09,5.8v-3.61c0-.26,0-.51,0-.77s0-.49,0-.72v-.09h0c.37-4.78,3.95-6.62,8.33-4.06a16.23,16.23,0,0,1,5,4.82c1-6.5,6.23-8.84,12.57-5.14,7.05,4.11,12.76,14.1,12.76,22.32v7.74a3.55,3.55,0,0,0,1.72,3l5.94,3.52a8.66,8.66,0,0,1,4.23,7.46,3.52,3.52,0,0,1-5.29,3.08l-55.17-32.2a9.77,9.77,0,0,1-4.82-8.44A3.12,3.12,0,0,1,375.67,100.17Z",
  style: {
    fill: "#e6e6e6"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M368.47,53.13,375,56.88V54.55c0-.17,0-.33,0-.49s0-.32,0-.48v0h0c.24-3.09,2.55-4.27,5.38-2.62A10.52,10.52,0,0,1,383.58,54c.64-4.2,4-5.71,8.12-3.32,4.55,2.65,8.24,9.11,8.24,14.42v5a2.29,2.29,0,0,0,1.11,2l3.84,2.27a5.6,5.6,0,0,1,2.73,4.82,2.28,2.28,0,0,1-3.42,2l-35.63-20.8a6.31,6.31,0,0,1-3.11-5.44A2,2,0,0,1,368.47,53.13Z",
  style: {
    fill: "#e6e6e6"
  }
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWorkHistoryTimeline, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/WorkHistoryTimeline.04181c62.svg";
export { ForwardRef as ReactComponent };